import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import HabitacionCard from "./HabitacionCard";

const groupRoomsByName = (rooms = []) => {
  if (!Array.isArray(rooms)) return [];

  const grouped = rooms.reduce((acc, room) => {
    if (!room?.name) return acc;

    if (!acc[room.name]) {
      acc[room.name] = {
        ...room,
        availability: Array.isArray(room.availability) ? [...room.availability] : [],
      };
    } else {
      const prev = Array.isArray(acc[room.name].availability) ? acc[room.name].availability : [];
      const next = Array.isArray(room.availability) ? room.availability : [];
      acc[room.name].availability = [...new Set([...prev, ...next])];
    }
    return acc;
  }, {});

  return Object.values(grouped);
};

const ListaHabitaciones = ({
  rooms,
  numGuests,
  totalNights,
  formatCurrency,
  calculateOffer,
  startDate,
  endDate,
  currency,
  propertyId,
  mpPublicKey,
  mpLocale,
  occupants,
  setOccupants,
  onOpenResumen, // opcional
}) => {
  const roomList = useMemo(() => groupRoomsByName(rooms), [rooms]);

  if (!Array.isArray(rooms) || rooms.length === 0) {
    return (
      <Typography sx={{ p: 2, color: "rgba(255,255,255,0.85)" }}>
        Cargando habitaciones...
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        px: { xs: 1, sm: 2 },
        py: { xs: 1, sm: 2 },
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {roomList.length > 0 ? (
        roomList.map((room) => {
          const roomCurrency = (room.currency || currency || "ARS").toUpperCase();

          return (
            <Box key={`${room.roomId}-${room.name}`} sx={{ width: "100%" }}>
              <HabitacionCard
                room={room}
                numGuests={numGuests}
                totalNights={totalNights}
                formatCurrency={formatCurrency}
                calculateOffer={calculateOffer}
                startDate={startDate}
                endDate={endDate}
                currency={roomCurrency}
                propertyId={propertyId}
                mpPublicKey={mpPublicKey}
                mpLocale={mpLocale}
                occupants={occupants}
                setOccupants={setOccupants}
                onOpenResumen={onOpenResumen}
              />
            </Box>
          );
        })
      ) : (
        <Typography
          variant="h6"
          sx={{ margin: "20px auto", textAlign: "center", color: "rgba(255,255,255,0.85)" }}
        >
          No hay habitaciones disponibles para las fechas seleccionadas.
        </Typography>
      )}
    </Box>
  );
};

export default ListaHabitaciones;
